/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { makeStyles } from '@mui/styles';
import Search from 'apollo-react-icons/Search';
import classNames from 'classnames';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { ZOOM_STYLES } from '../../../constants/CommonStylesConstants';
import ZoomDialog from '../../../form-designer/controls/ssZoom/ZoomDialog';
import { getSavedSearchTitle } from '../../../saved-search-designer/selectors/editor.selectors';

const useStyles = makeStyles({
  ...ZOOM_STYLES,
  control: {
    position: 'absolute',
    marginLeft: -40,
    zIndex: 10,
    marginTop: 28,
    '@media (max-width: 480px)': {
      marginTop: 45,
    },
  },
});

const ZoomControl = ({
  title,
  entityName,
  savedSearchName = '',
  handleOnSelect,
  multiSelect = false,
}) => {
  const classes = useStyles();
  const searchTableTitle = useSelector((state) =>
    getSavedSearchTitle(state, {
      entityName,
      savedSearchName,
      defaultTitle: title,
    })
  );

  const [dialogOpen, setDialogOpen] = useState(false);

  const onSelect = (selection) => {
    setDialogOpen(false);
    handleOnSelect(selection);
  };

  return (
    <>
      <span
        className={classNames(classes.root, classes.control)}
        onClick={() => setDialogOpen(true)}
      >
        <Search className={classes.searchIcon} />
      </span>
      <ZoomDialog
        open={dialogOpen}
        onSelect={onSelect}
        onClose={() => setDialogOpen(false)}
        multiSelect={multiSelect}
        entityName={entityName}
        initialSearchName={savedSearchName}
        customFilter={{}}
        title={searchTableTitle}
        referencedColumns={[]}
        translatedSearchName={searchTableTitle}
        dynamicParamCollection={{}}
      />
    </>
  );
};

export default ZoomControl;
